import React from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { PWAInstallProvider } from "@/context/PWAInstallContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Dossiers from "@/pages/Dossiers";
import Reclamations from "@/pages/Reclamations";
import Appels from "@/pages/Appels";
import Clients from "@/pages/Clients";
import GED from "@/pages/GED";
import Users from "@/pages/Users";
import Historique from "@/pages/Historique";
import FileAttente from "@/pages/FileAttente";
import BorneTicket from "@/pages/BorneTicket";
import EcranAffichage from "@/pages/EcranAffichage";
import Parametres from "@/pages/Parametres";
import BaseConnaissances from "@/pages/BaseConnaissances";
import Discussions from "@/pages/Discussions";
import Messagerie from "@/pages/Messagerie";
import Analytics from "@/pages/Analytics";
import Inscription from "@/pages/Inscription";
import Prospects from "@/pages/Prospects";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <ThemeProvider defaultTheme="light">
        <PWAInstallProvider>
          <BrowserRouter>
            <AuthProvider>
              <Routes>
                {/* Public routes (kiosks / display) */}
                <Route path="/borne" element={<BorneTicket />} />
                <Route path="/ecran" element={<EcranAffichage />} />

                <Route path="/login" element={<Login />} />
                <Route path="/inscription" element={<Inscription />} />

                <Route
                  element={
                    <ProtectedRoute>
                      <AppLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Dashboard />} />
                  <Route path="dossiers" element={<Dossiers />} />
                  <Route path="reclamations" element={<Reclamations />} />
                  <Route path="appels" element={<Appels />} />
                  <Route path="clients" element={<Clients />} />
                  <Route path="file-attente" element={<FileAttente />} />
                  <Route path="ged" element={<GED />} />
                  <Route path="historique" element={<Historique />} />
                  <Route path="base-connaissances" element={<BaseConnaissances />} />
                  <Route path="discussions" element={<Discussions />} />
                  <Route path="messagerie" element={<Messagerie />} />
                  <Route
                    path="parametres"
                    element={
                      <ProtectedRoute roles={["admin"]}>
                        <Parametres />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="utilisateurs"
                    element={
                      <ProtectedRoute roles={["admin"]}>
                        <Users />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="analytics"
                    element={
                      <ProtectedRoute roles={["admin", "directeur"]}>
                        <Analytics />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="prospects"
                    element={
                      <ProtectedRoute roles={["admin", "directeur"]}>
                        <Prospects />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                {/* Catch-all: any unknown URL (e.g. legacy /change-password) sends the user home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <PWAInstallPrompt />
              <Toaster richColors position="bottom-right" />
            </AuthProvider>
          </BrowserRouter>
        </PWAInstallProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
